import React from 'react';
import LmsLookupDefinitionsPage from '../lookup-definitions/LmsLookupDefinitionsPage';

const TrainingLocationDefinitions = () => <LmsLookupDefinitionsPage groupCode="TRAINING_LOCATION" pageTitleKey="trainingLocationDefinitions.title" />;

export default TrainingLocationDefinitions;
